import React from 'react';
import PropTypes from 'prop-types';

class ProgressBar extends  React.Component {
    constructor(props, context) {
        super(props);
        this.state = {           
        }
    }

    shouldComponentUpdate(){
        return true;
    }

    render() {       
        
        var _percentage = isNaN(this.props.percentage) ? 0 : this.props.percentage;
        var _stylePercentage = { 
            width: _percentage + "%"
        }; 

        return (
            <div className="mg-progress">
                <div className="progress-percentage"> {_percentage} %</div>
                <div className="progress-bar" role="progressbar" aria-valuenow={_percentage} 
                    aria-valuemin="0" aria-valuemax="100" style={_stylePercentage}>                                    
                </div>
            </div>
            );
    }
    
}
ProgressBar.propTypes = {
    percentage: PropTypes.number
};

ProgressBar.defaultProps = {
    percentage: 0
};

export default ProgressBar;